import { Enrolment } from '@/models/enrolment';
import { EnrolmentStatus } from '@/models/enrolment-status';
import EnrolmentService from '@/services/enrolments-service';

import { EnrolmentDisqualifiedTriggerPayloadConfiguration } from '../trigger-payload/enrolment-disqualified-trigger-payload-configuration';
import { TriggerPayload } from '../trigger-payload/trigger-payload';
import { TransitionTrigger } from './transition-trigger';

export class EnrolmentDisqualifiedTrigger extends TransitionTrigger {
	public orderingNumber = 32;

	public constructor(excludedEnrolmentStatuses: EnrolmentStatus[]) {
		super('Disqualified', excludedEnrolmentStatuses, new EnrolmentDisqualifiedTriggerPayloadConfiguration());
	}

	public equals(that: TransitionTrigger): boolean {
		return that instanceof EnrolmentDisqualifiedTrigger;
	}

	protected async performTransitions(enrolments: Readonly<Enrolment[]>, payload: TriggerPayload): Promise<void> {
		await EnrolmentService.triggerEnrolmentDisqualified(enrolments, payload.disqualificationReasonSelection, payload.note);
	}
}
